import React from 'react';

import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import CONFIG from '../../../config';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterListIcon from '@mui/icons-material/FilterList';
import TrelloBoard from './TrelloBoard';
import WidgetCheckbox from '../../../components/widgets/WidgetCheckbox';
import WidgetDatePicker from '../../../components/widgets/WidgetDatePicker';
import WidgetInputText from '../../../components/widgets/WidgetInputText';
import WidgetInputVilleList from '../../../components/widgets/WidgetInputVilleList';
import WidgetSelect from '../../../components/widgets/WidgetSelect';


function VueEnsemble() {
  const navigate = useNavigate();

  function downloadFile(fileName, urlData) {
    var aLink = document.createElement('a');
    aLink.download = fileName;
    aLink.href = urlData;

    var event = new MouseEvent('click');
    aLink.dispatchEvent(event);
  }

  const [commerciauxOption, setCommerciauxOption] = React.useState({});
  const [secteurOption, setSecteurOption] = React.useState({});
  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/get_secteurs', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            let res = {};
            for (let i = 0; i < response.data.length; i++) {
              const secteurItem = response.data[i];
              res[secteurItem.toLowerCase()] = secteurItem;
            }
            res["autre"] = "Autre...";

            setSecteurOption(res);
            break;

          default:
            break;
        }
      })
      .catch((e) => {

      });
  }, []);


  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/me', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            if (response.data.roles.role_admin_read || response.data.roles.role_admin_write) {
              axios.get(CONFIG.API_URL + '/api/get_all_commercial', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then((response) => {
                  switch (response.status) {
                    case 200:
                      var temp_commerciaux = {};

                      for (let i = 0; i < response.data.length; i++) {
                        if (response.data[i].nom.trim() === '' && response.data[i].prenom.trim() === '')
                          temp_commerciaux[response.data[i]._id] = 'Sans nom (' + response.data[i]._id + ')';
                        else
                          temp_commerciaux[response.data[i]._id] = response.data[i].nom + ' ' + response.data[i].prenom;
                      }

                      setCommerciauxOption(temp_commerciaux);
                      break;

                    default:
                      break;
                  }
                })
                .catch((e) => {
                  let response = e.response;

                  if (response === undefined) {
                    alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                    return;
                  }

                  switch (response.status) {
                    default:
                      alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                      break;
                  }
                });
            } else {
              setCommerciauxOption({});
            }
            break;
          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          case 401:
            navigate('/connexion');
            break;
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  }, []);



  const [displayFilters, setDisplayFilters] = React.useState(false);

  const [nom, setNom] = React.useState(null);
  const [prenom, setPrenom] = React.useState(null);
  const [contrat, setContrat] = React.useState(null);
  const [avecEssai, setAvecEssai] = React.useState(null);
  const [revenuNet, setRevenuNet] = React.useState(null);
  const [secteur, setSecteur] = React.useState(null);
  const [villesRecherche, setVillesRecherche] = React.useState(null);
  const [maxLoyer, setMaxLoyer] = React.useState(null);
  const [typologie, setTypologie] = React.useState(null);
  const [typeMeuble, setTypeMeuble] = React.useState(null);
  const [nomEntreprise, setNomEntreprise] = React.useState(null);
  const [commercial, setCommercial] = React.useState(null);

  const [tri, setTri] = React.useState(null);

  const applyFilter = (data) => {
    return data.filter((x) => (
      x.nom.toLowerCase().includes(nom?.value.toLowerCase())
      && x.prenom.toLowerCase().includes(prenom?.value.toLowerCase())
      && (contrat?.value?.length === 0 || contrat?.value.includes(x.dossier.type_contrat.toLowerCase()))
      && (['', 'osef', 'autre', null].includes(avecEssai?.value.toLowerCase()) || x.dossier.avec_essai === (avecEssai?.value === 'true'))
      && (revenuNet?.value === '' || parseFloat(revenuNet?.value) <= parseFloat(x.dossier.revenu_net))
      && (villesRecherche?.value?.length === 0 || villesRecherche?.value.some(item => x.dossier.villes_recherche.includes(item)))
      && (maxLoyer?.value === '' || parseFloat(maxLoyer?.value) >= parseFloat(x.dossier.max_loyer))
      && (secteur?.value?.length === 0 || secteur?.value.includes(x.dossier.secteur_recherche))
      && (typologie?.value?.length === 0 || typologie?.value.some(item => x.dossier.type_appartement_recherche.includes(item)))
      && (['', 'osef', 'autre', null].includes(typeMeuble?.value) || x.dossier.type_meuble.toLowerCase() === typeMeuble?.value.toLowerCase())
      && (['', 'osef', 'autre', null].includes(nomEntreprise?.value) || x.dossier.nom_entreprise.toLowerCase().includes(nomEntreprise?.value.toLowerCase()))
      && (commercial?.value?.length === 0 || commercial?.value.includes(x.dossier.id_commercial)) 
      && (['incomplet','complet','verifie','attribue','valide','envoye'].includes(x?.dossier?.etat))
    ))
  }

  const applySort = (data, sortType) => {
    return data.sort((a, b) => {
      switch (sortType) {
        case "nom_up":
          return (a.nom > b.nom) ? 1 : -1;
        case "nom_down":
          return (a.nom < b.nom) ? 1 : -1;
      }
    })
  }


  const [userList, setUserList] = React.useState([]);
  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/get_all_clients', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            setUserList(response.data);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          case 401:
            navigate('/connexion');
            break;

          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  }, []);


  return (
    <>
      <div className='m-6 grid grid-cols-12 gap-x-4 shrink-0 w-100 bg-white my-shadow'>
        <div className='col-span-12 grid grid-cols-12 p-6 hover:bg-gray-100 cursor-pointer rounded-xl' onClick={() => setDisplayFilters(!displayFilters)}>
          <div className='col-span-6 w-full flex items-center'>
            <div className='inline-block'><FilterListIcon /></div>
            <div className='inline-block'><h3>&nbsp;Filtres & tris</h3></div>
          </div>
          <div className='col-span-6 w-full flex items-center justify-end'>
            <div className='inline-block'>{(!displayFilters) ? <ExpandMoreIcon fontSize="large" /> : <ExpandLessIcon fontSize="large" />}</div>
          </div>
        </div>
        <div className='col-span-12 w-full px-6 shadow-inner shadow-gray-100 bg-gray-50'>
          <Collapse in={displayFilters}>
            <hr className='mb-6'></hr>
            <div className='w-full grid grid-cols-10 gap-4 pb-2'>
              <div className='col-span-2 w-full mb-4'>
                <WidgetInputText state={nom} setState={setNom} id={'nom'} text={"Nom"} />
              </div>

              <div className='col-span-2 w-full mb-4'>
                <WidgetInputText state={prenom} setState={setPrenom} id={'prenom'} text={"Prénom"} />
              </div>

              <div className='col-span-2 w-full mb-4'>
                <WidgetSelect state={contrat} setState={setContrat} id={'type_contrat'} text={"Type de contrat"} multiple={true}
                  options={{
                    'cdi': "CDI",
                    'cdd': "CDD",
                    'alternance': "Alternance"
                  }}
                />
              </div>

              <div className='col-span-2 w-full mb-4'>
                <WidgetSelect state={avecEssai} setState={setAvecEssai} id={'avec_essai'} text={"Avec essai"}
                  options={{
                    'osef': "Peu importe",
                    true: "Oui",
                    false: "Non"
                  }}
                />
              </div>

              <div className='col-span-2 w-full mb-4'>
                <WidgetInputText state={revenuNet} setState={setRevenuNet} id={'revenu_net'} text={"Revenu net min"} />
              </div>

              <div className='col-span-2 w-full mb-4'>
                <WidgetSelect state={secteur} setState={setSecteur} id={'secteur'} text={"Secteur"} multiple={true}
                  options={secteurOption}
                />
              </div>

              <div className='col-span-2 w-full mb-4'>
                <WidgetInputVilleList state={villesRecherche} setState={setVillesRecherche} id={'ville_recherche'} text={"Ville recherche"} />
              </div>

              <div className='col-span-2 w-full mb-4'>
                <WidgetInputText state={maxLoyer} setState={setMaxLoyer} id={'max_loyer'} text={"Max loyer"} />
              </div>

              <div className='col-span-2 w-full mb-4'>
                <WidgetSelect state={typologie} setState={setTypologie} id={'type_appartement_recherche'} text={"Typologie"} multiple={true}
                  options={{
                    'studio': "Studio",
                    't2': "T2 (1 chambre)",
                    't3': "T3 (2 chambres)",
                    't4+': "T4 ou plus (3 chambres)"
                  }}
                />
              </div>

              <div className='col-span-2 w-full mb-4'>
                <WidgetSelect state={typeMeuble} setState={setTypeMeuble} id={'type_meuble'} text={"Meublé/Non meublé"}
                  options={{
                    'osef': "Peu importe",
                    'meuble': "Meublé",
                    'non-meuble': "Non meublé"
                  }}
                />
              </div>

              <div className='col-span-2 w-full mb-4'>
                <WidgetInputText state={nomEntreprise} setState={setNomEntreprise} id={'nom_entreprise'} text={"Nom entreprise"} />
              </div>

              <div className='col-span-2 w-full mb-4'>
                <WidgetSelect state={commercial} setState={setCommercial} id={'commercial'} text={"Attribué à"} multiple={true} readOnly={Object.keys(commerciauxOption).length === 0}
                  options={commerciauxOption}
                />
              </div>

              <div className='col-span-2 w-full mb-4'>
                <WidgetSelect state={tri} setState={setTri} id={'tri'} text={"Tri"} value={"nom_down"}
                  options={{
                    'nom_up': "Nom ↑",
                    'nom_down': "Nom ↓",
                  }}
                />
              </div>
            </div>
          </Collapse>
        </div>
      </div>


      <div className='m-6 grid grid-cols-12 gap-x-4 shrink-0 w-100 bg-white my-shadow'>
        <div className='col-span-12 w-full gap-x-4 shrink-0'>
          <TrelloBoard state={applySort(applyFilter(userList), tri?.value)} setState={setUserList}
            cols={{
              'incomplet': "Attente pièces",
              'complet': "À vérifier",
              'verifie': "À attribuer",
              'attribue': "En recherche",
              'valide': "Validé",
              'envoye': "Envoyé organisme",
            }}
          />
        </div>

        <div className='col-span-12 w-full px-6 pb-6 text-right'>
          <div className='pr-2 inline-block'>
            <Button variant='outlined' onClick={() => {
              let payload = {
                nom: nom.value,
                prenom: prenom.value,
                contrat: contrat.value,
                avec_essai: (avecEssai.value === 'osef' ? null : (avecEssai.value === 'true' ? true : false)),
                revenu_net: revenuNet.value,
                secteur: secteur.value,
                villes_recherche: villesRecherche.value,
                max_loyer: maxLoyer.value,
                typologie: typologie.value,
                type_meuble: typeMeuble.value,
                nom_entreprise: nomEntreprise.value,
                commercial: commercial.value,
              }
              axios.post(CONFIG.API_URL + '/api/extract_csv_client', payload, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then((response) => {
                  switch (response.status) {
                    case 200:
                      downloadFile('clients.csv', 'data:text/csv;charset=UTF-8,' + encodeURIComponent(response.data));
                      break;

                    default:
                      break;
                  }
                })
                .catch((e) => {
                  let response = e.response;

                  if (response === undefined) {
                    alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                    return;
                  }

                  switch (response.status) {
                    default:
                      alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                      break;
                  }
                });
            }}>
              Extraire en CSV
            </Button>
          </div>
          <div className='inline-block'>
            <Button variant='contained' onClick={() => {
              var win = window.open();
              applySort(applyFilter(userList), tri?.value).map(x => win.document.write(x.email + "<br>"));
              win.focus();
            }}>
              Extraire les emails
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default VueEnsemble;